import { breakpoint } from './breakpoint-setup'

if (breakpoint('screen') > breakpoint('xxl')) {
  let fontCoef = breakpoint('screen') / 1440
  let fontSize = Math.floor(16 * fontCoef)
  fontSize = fontSize > 32 ? 32 : fontSize
  $('html').css('font-size', fontSize + 'px')
}



document.addEventListener('DOMContentLoaded', function (event) {})

$(window).on('load', function (){

  $('.close-search-popup').css('top', $('header').outerHeight())

  setTimeout(function (e){
    $('body').removeAttr('style')
    $('.scroll-animation-container').removeClass('hidden')
    $('.dom-load').removeClass('dom-load')
    $('.timeline-loader').addClass('loaded')
    $('.menu').addClass('visible')
  }, 200)


})
